import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const getChangeLog = async () => {
    Store.dispatch(loadingActions.loadingStart('changelog.get'));
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOME}/app/changelog.json`);
        Store.dispatch(loadingActions.loadingEnd('changelog.get'));

        return resp.data || [];
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('changelog.get'));
        console.error(Object.assign(e,{component:'ChangeLog', id: 'getChangeLog'}));
        return [];
    }
}
